import dynamic from 'next/dynamic'

const TravelChatBot = dynamic(() => import('./TravelChatBot'), {
  ssr: false
})

export default TravelChatBot
